<script lang="ts">
  import { setContext } from 'svelte';
  import { link } from 'svelte-spa-router';
  import { menuConfig, sidebarOpen } from '$stores/ui.js';
  import SearchBar from './SearchBar.svelte';
  import MenuGroup from './MenuGroup.svelte';

  let openGroup: string | null = null;

  // Any leaf click at any nesting depth calls this via context.
  setContext('closeAll', () => { openGroup = null; });

  function toggleSidebar() {
    sidebarOpen.update((v) => !v);
  }

  function onWindowClick(e: MouseEvent) {
    // Close if the click lands outside every top-level menu group.
    if (!(e.target as Element).closest('.wrap.is-top')) {
      openGroup = null;
    }
  }
</script>

<svelte:window on:click={onWindowClick} />

<header class="menubar">
  <button class="hamburger" on:click={toggleSidebar} aria-label={__STRINGS__.nav.toggleSidebar}>
    <span></span>
    <span></span>
    <span></span>
  </button>

  <a href="/" use:link class="logo">
    {__SITE_TITLE__}
  </a>

  <nav class="menu" aria-label="Main navigation">
    {#each $menuConfig as item}
      <MenuGroup
        {item}
        depth={0}
        isOpen={openGroup === item.label}
        on:open={() => (openGroup = item.label)}
        on:close={() => (openGroup = null)}
      />
    {/each}
  </nav>

  <div class="spacer"></div>

  <div class="search-wrapper">
    <SearchBar />
  </div>

  <slot name="actions"></slot>
</header>

<style>
  .menubar {
    display: flex;
    align-items: center;
    height: 56px;
    padding: 0 1rem;
    background: var(--color-menubar-bg, #1a1a2e);
    color: var(--color-menubar-text, #fff);
    position: sticky;
    top: 0;
    z-index: 100;
  }

  .hamburger {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 4px;
    width: 32px;
    height: 32px;
    padding: 4px;
    background: none;
    border: none;
    cursor: pointer;
    margin-right: 0.5rem;
    min-width: 26px;
  }

  .hamburger span {
    display: block;
    width: 100%;
    height: 2px;
    background: var(--color-menubar-text, #fff);
    border-radius: 1px;
  }

  .logo {
    font-size: 1.25rem;
    font-weight: 700;
    color: var(--color-menubar-text, #fff);
    text-decoration: none;
    margin-right: 2rem;
  }

  .menu {
    display: flex;
    gap: 0.25rem;
    align-items: center;
  }

  .spacer {
    flex: 1;
  }

  .search-wrapper {
    margin-right: 1rem;
  }

  @media (max-width: 768px) {
    .menu {
      display: none;
    }
  }
</style>
